import React, { Component } from 'react'
import { withRouter } from 'react-router'
import Modal from 'react-modal'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import ProjectUserListPageUI from './ProjectUserListPageUI.js'

class ProjectUserListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      project: null,
      projectUserList: null,
      filteredProjectUserList: null,
      allRoleList: [],
      // filters
      memberFilter: true,
      nonMemberFilter: true,
      searchFilter: '',


      successMsg: null,
      errorList: null,
      updateMode: false,
      deleteMode: false,
      submitted: false,
      selectedCount: 0,
      // update form
      roleId: '',
      roleList: []
    }
  }

  render() {
    return (
      <ProjectUserListPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        project={this.state.project}
        projectUserList={this.state.projectUserList}
        filteredProjectUserList={this.state.filteredProjectUserList}
        // filters
        searchFilter={this.state.searchFilter}
        memberFilter={this.state.memberFilter}
        nonMemberFilter={this.state.nonMemberFilter}
        onMemberFilterClick={this.onMemberFilterClick}
        onNonMemberFilterClick={this.onNonMemberFilterClick}
        onSearchFilterChange={this.onSearchFilterChange}
        // form
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={(errorList) => {this.setState({errorList: errorList})}}
        // modes
        selectedCount={this.state.selectedCount}
        updateMode={this.state.updateMode}
        deleteMode={this.state.deleteMode}
        submitted={this.state.submitted}
        // events
        onRowClick={this.onRowClick}
        onRefreshClick={this.onRefreshClick}
        onUpdateClick={this.onUpdateClick}
        onDeleteClick={this.onDeleteClick}
        onConfirmInviteClick={this.onConfirmInviteClick}
        onConfirmUpdateClick={this.onConfirmUpdateClick}
        onConfirmDeleteClick={this.onConfirmDeleteClick}
        onCancelClick={this.onCancelClick}
        // update form
        roleId={this.state.roleId}
        roleList={this.state.roleList}
        onRoleIdChange={this.onRoleIdChange}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getProjectUsers(context)
    this.getProjects(context)
    this.getMessages(context)
    this.getRoles(context)
    // https://stackoverflow.com/questions/48269381/warning-react-modal-app-element-is-not-defined-please-use-modal-setappeleme
    Modal.setAppElement('body')
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  getProjectUsers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/projects/${this.props.match.params.projectId}/users`,
      cacheKey: CacheKeys.ProjectUsers(this.props.match.params.projectId),
      callback: this.getProjectUsersCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getProjectUsersCallback = (response) => {
    response.projectUserList && response.projectUserList.forEach(user => {
      user.selected = false
    })

    let filtersStr = sessionStorage.getItem(CacheKeys.ProjectUsersFilter(this.props.match.params.projectId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.setState({
      projectUserList: response.projectUserList,
      filteredProjectUserList: response.projectUserList,
      searchFilter: filters.searchFilter ? filters.searchFilter : '',
      memberFilter: filters.hasOwnProperty('memberFilter') ? filters.memberFilter : true,
      nonMemberFilter: filters.hasOwnProperty('nonMemberFilter') ? filters.nonMemberFilter : true
    })


    this.applyFilters(response.projectUserList,
      filters.hasOwnProperty('memberFilter') ? filters.memberFilter : true,
      filters.hasOwnProperty('nonMemberFilter') ? filters.nonMemberFilter : true,
      filters.searchFilter ? filters.searchFilter : '')
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.ProjectUsers(this.props.match.params.projectId))
    this.setState({errorList: null, projectUserList: null, filteredProjectUserList: null})
    this.getProjectUsers(context)
  }

  getProjects(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/projects`,
      cacheKey: CacheKeys.Projects(context.session.accountId, context.session.userId),
      callback: this.getProjectsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getProjectsCallback = (response) => {
    if (response.errorList.length > 0) {
      this.props.history.replace('/projects')
      return
    }
    let projectsFiltered = response.projectList.filter(project => project.projectId === this.props.match.params.projectId)
    if (projectsFiltered.length === 1) {
      this.setState({projectList: response.projectList, project : projectsFiltered[0]})
    }
    else {
      let context = this.props.context
      CacheManager.removeObject(CacheKeys.Projects(context.session.accountId, context.session.userId))
      this.props.history.replace('/projects')
    }
  }

  onMemberFilterClick = () => {
    let memberFilter = !this.state.memberFilter
    this.setState({memberFilter: memberFilter})
    this.applyFilters(this.state.projectUserList, memberFilter, this.state.nonMemberFilter, this.state.searchFilter)
  }

  onNonMemberFilterClick = () => {
    let nonMemberFilter = !this.state.nonMemberFilter
    this.setState({nonMemberFilter: nonMemberFilter})
    this.applyFilters(this.state.projectUserList, this.state.memberFilter, nonMemberFilter, this.state.searchFilter)
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({searchFilter: searchFilter})
    this.applyFilters(this.state.projectUserList, this.state.memberFilter, this.state.nonMemberFilter, searchFilter)
  }

  applyFilters(projectUserList, memberFilter, nonMemberFilter, searchFilter) {
    let filteredList = projectUserList
    if (!memberFilter)
      filteredList = filteredList.filter(user => user.roleId === null)
    if (!nonMemberFilter)
      filteredList = filteredList.filter(user => user.roleId !== null)
    if (searchFilter)
      filteredList = filteredList.filter(user => user.name.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()))

    // remove checked flag from rows that are hidden
    let selectedSet = new Set()
    projectUserList.filter(user => user.selected).forEach(user => {selectedSet.add(user.userId)})
    projectUserList.forEach(user => {user.selected = false})
    filteredList.filter(user => selectedSet.has(user.userId)).forEach(user => {user.selected = true})

    this.setState({
      filteredProjectUserList: filteredList,
      selectedCount: filteredList.filter(user => user.selected).length
    })

    let filters = {searchFilter: searchFilter, memberFilter: memberFilter, nonMemberFilter: nonMemberFilter}
    sessionStorage.setItem(CacheKeys.ProjectUsersFilter(this.props.match.params.projectId), JSON.stringify(filters))
  }

  onRowClick = event => {
    let userId = event.currentTarget.getAttribute('data-row-id')
    let projectUserList = this.state.projectUserList
    projectUserList
      .filter(user => user.userId === userId)
      .forEach(user => {
      user.selected = !Boolean(user.selected)
    })

    this.setState({projectUserList : projectUserList})
    this.applyFilters(projectUserList, this.state.memberFilter, this.state.nonMemberFilter,
      this.state.searchFilter)
  }

  onUpdateClick = () => {
    // prepare role list
    let multiRole = false
    let firstRoleId = null
    this.state.filteredProjectUserList.filter(user => user.selected).forEach(user => {
      if (!firstRoleId)
        firstRoleId = user.roleId
      else if (firstRoleId !== user.roleId)
        multiRole = true
    })

    let roleList = this.state.allRoleList
    if (!multiRole)
      roleList = roleList.filter(role => role.key !== firstRoleId)

    let roleId = roleList.length > 0 ? roleList[0].key : ''

    this.setState({updateMode: true, roleList: roleList, roleId: roleId})
  }

  onDeleteClick = () => {
    this.setState({deleteMode: true})
  }

  onCancelClick = () => {
    this.setState({updateMode:false, deleteMode: false, errorList: null})
  }

  onRoleIdChange = (event) => {
    this.setState({roleId: event.target.value})
  }

  onConfirmUpdateClick = () => {
    this.setState({submitted: true})
    let userIds = this.state.projectUserList
      .filter(user => user.selected)
      .map(user => user.userId)
      .toString()

    RestApiUtils.put(this.props.context,
      `/api/projects/${this.props.match.params.projectId}/users/${userIds}`,
      this.onConfirmUpdateOrDeleteCallback, {
        roleId: this.state.roleId,
      }
    )
  }

  onConfirmDeleteClick = () => {
    let context = this.props.context
    this.setState({submitted: true})
    let userIds = this.state.projectUserList
      .filter(user => user.selected)
      .map(user => user.userId)
      .toString()

    RestApiUtils.delete(context,
      `/api/projects/${this.props.match.params.projectId}/users/${userIds}`,
      this.onConfirmUpdateOrDeleteCallback
    )
  }

  onConfirmUpdateOrDeleteCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
      this.setState({submitted: false, errorList: errorList})
      return
    }

    let projectUserList = this.state.projectUserList.map(user => {
      user.selected = false
      let responseProjectUser = response.projectUserList
        .filter(responseProjectUser => user.userId === responseProjectUser.userId)
      if (responseProjectUser.length === 1)
        responseProjectUser[0].selected = false
      return responseProjectUser.length === 1 ? responseProjectUser[0] : user
    })

    this.setState({
      submitted: false,
      successMsg: response.success,
      projectUserList: projectUserList,
    })

    let context = this.props.context
    CacheManager.removeObject(CacheKeys.ProjectUsers(this.props.match.params.projectId))

    // check if current user is in the list, in that case refetch projects
    // because projects includes user's permissions
    let currentUser = response.projectUserList.filter(user => user.userId === context.session.userId)
    if (currentUser.length > 0) {
      CacheManager.removeObject(CacheKeys.Projects(context.session.accountId, context.session.userId))
      if (this.state.deleteMode) {
        this.props.history.replace('/projects')
      }
      else {
        this.getProjects(context)
      }
    }

    // need to refresh task lists because assignees need to be updated
    // also need to refresh task tree and project users cache as deleted users are removed from project
    CacheManager.removeByPrefix('TaskTree')
    CacheManager.removeByPrefix('ProjectUsers')

    this.applyFilters(projectUserList, this.state.memberFilter, this.state.nonMemberFilter, this.state.searchFilter);

    setTimeout(() => {
      this.setState({updateMode: false, deleteMode: false, successMsg: null})
    }, 2000);
  }

  getRoles(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/roles/project/locales/${context.locale}`,
      cacheKey: CacheKeys.Roles('project', context.locale),
      callback: this.getRolesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getRolesCallback = (response) => {
    let allRoleList = response.roleList.map(role => ({key: role.roleId, value: role.roleName}))
    this.setState({
      allRoleList: allRoleList,
    })
  }

  getMessages(context) {
    let arr = [
      'c_project_users',
      'c_members',
      'c_non_members',
      //
      'c_refresh',
      'c_invite_user',
      // update
      'c_update_users',
      'c_update',
      'c_cancel',
      'c_new_role',
      // remove
      'c_remove_users',
      'c_remove_users_conf',
      'c_yes_remove',
      'c_do_not_remove',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_prj_users', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(ProjectUserListPageSF)
